import Avatar from '@/support/Avatar';
import { User } from '@/models/User';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Application } from '@/support/Application';
import { MiSearchOptions } from '@/components/MiGlobalSearch/MiGlobalSearch.ts';

@Component<Navigation>({
  components: {},
})
export default class Navigation extends Vue {
  @Prop({ default: () => [] })
  protected items!: NavigationItem[];

  protected internalItems: NavigationItem[] = [];

  protected isDisplayingMobileMenu = false;

  protected mounted(): void {
    this.items.forEach((item: NavigationItem) => {
      item.isDisplayingChildren = false;
    });

    this.$set(this, 'internalItems', this.items);
  }

  protected logout(): void {
    this.$store.dispatch('userDeauthenticated');
    this.$router.push('/login');
  }

  protected createAvatar(name: string): string {
    return new Avatar(name, {
      size: 128,
    }).toDataUrl();
  }

  protected get user(): User|null {
    return this.$store.getters.user || null;
  }

  protected get userAvatar(): string {
    const name = this?.user?.name || '-';

    return new Avatar(name, {
      size: 128,
    }).toDataUrl();
  }

  protected get isMobile(): boolean {
    return this.$store.getters.isMobile;
  }

  protected onClickMobileMenu(): void {
    this.isDisplayingMobileMenu = ! this.isDisplayingMobileMenu;
  }

  protected onChangeEvent(value: string | number, option: MiSearchOptions): void {
    this.$router.push(`/${option.url}/${value}`);
  }

  protected toggleChildren(index: number): void {
    const isDisplayingChildren = this.items[index].isDisplayingChildren;
    this.$set(this.internalItems[index], 'isDisplayingChildren', ! isDisplayingChildren);
  }

  protected get isAcceptance() {
    return Application.config('APP_ENV') === 'acceptance';
  }
}

export interface NavigationItem {
  title: string;
  icon?: string;
  to?: string;
  children?: NavigationItem[];
  visible?: (() => boolean) | boolean;
  isDisplayingChildren?: boolean;
}
